/**
 * Valida si el timestamp del JWT ha expirado. Retorna true si sigue vigente.
 */
const checkTimeStampLoggedUser = (exp) => Math.floor(Date.now() / 1000) < exp;

export default checkTimeStampLoggedUser;
